import { Box, Typography } from "@carrotfertility/carotene-core"
import React from "react"
import { FormattedMessage } from "react-intl"
import { HelpGlyph } from "#/components/talk-to-carrot/HelpGlyph"

const TalkToCarrotLegal = () => (
  <Box
    sx={(theme) => ({
      display: "flex",
      marginBlockStart: theme.tokens.spacing.lg,
      marginBlockEnd: theme.tokens.spacing.xxxl,
      paddingBlockStart: theme.tokens.spacing.xs,
      borderBlockStart: `1px solid #ebebeb`,
      [theme.breakpoints.down("md")]: {
        flexWrap: "wrap"
      }
    })}
  >
    <Box
      sx={(theme) => ({
        display: "flex",
        marginInline: theme.spacing(0, theme.tokens.spacing.md),
        marginBlockEnd: theme.tokens.spacing.xs
      })}
    >
      <HelpGlyph />
    </Box>
    <div>
      <Typography variant="body2" color={(theme) => theme.palette.text.tertiary}>
        <FormattedMessage defaultMessage="Carrot resources are for informational purposes only and do not constitute medical advice or professional services. They are not a substitute for legal, tax, licensed clinical care, or professional medical advice, diagnosis, or treatment. If you are experiencing a medical emergency, call emergency services immediately." />
      </Typography>
    </div>
  </Box>
)

export { TalkToCarrotLegal }
